module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"companyName":"Company Name"}}')
  delete Component.options._Ctor
}
